import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/pages/home/home'
import OurOffice from '@/pages/our-office/our-office'
import Braces from '@/pages/braces/braces'
import Invisalign from '@/pages/invisalign/invisalign'
import LucasDifference from '@/pages/lucas-difference/lucas-difference'
import NewPatients from '@/pages/new-patients/new-patients'
import Contact from '@/pages/contact/contact'
import ThankYou from '@/pages/thank-you/thank-you'
import Accessibility from '@/pages/accessibility/accessibility'
import PageNotFound from '@/pages/404/404'
import scrollBehavior from '@/shared/functionality/scroll-behavior'
import Blog from '@/pages/blog/blog'
import BlogTemplate from '@/pages/blog-template/blog-template'
import Styleguide from '@/styleguide/styleguide'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      navigation: false,
      component: Home
    },
    {
      path: '/our-office',
      name: 'Our Office',
      navigation: 'left',
      component: OurOffice,
      children: [
        {
          icon: 'nav-meet-dr-lucas',
          name: 'Meet Dr Lucas',
          path: '/our-office#doctor'
        },
        {
          icon: 'nav-meet-team',
          name: 'Meet The A Team',
          path: '/our-office#team'
        },
        {
          icon: 'nav-office-tour',
          name: 'Tour Our Office',
          path: '/our-office#tour'
        },
        {
          icon: 'nav-types-braces-invisalign',
          name: 'Kids Club & Contests',
          path: '/our-office#kids'
        },
        {
          icon: 'nav-community',
          name: 'Monthly Contest',
          path: '/our-office#contest'
        }
      ]
    },
    {
      path: '/braces',
      name: 'Braces',
      navigation: 'left',
      component: Braces,
      children: [
        {
          icon: 'nav-types-braces-invisalign',
          name: 'Types Of Braces',
          path: '/braces#types'
        },
        // {
        //   icon: 'nav-cost-braces-invisalign',
        //   name: 'Cost Of Braces',
        //   path: '/braces#cost'
        // },
        {
          icon: 'nav-braces-faq',
          name: 'Braces FAQ',
          path: '/braces#faq'
        }
      ]
    },
    {
      path: '/invisalign',
      name: 'Invisalign',
      navigation: 'left',
      component: Invisalign,
      children: [
        {
          icon: 'nav-types-braces-invisalign',
          name: 'How Invisalign Works',
          path: '/invisalign#works'
        },
        // {
        //   icon: 'nav-cost-braces-invisalign',
        //   name: 'Invisalign Cost',
        //   path: '/invisalign#cost'
        // },
        {
          icon: 'nav-invisalign-teen',
          name: 'Invisalign Teen',
          path: '/invisalign#teen'
        }
      ]
    },
    {
      path: '/lucas-difference',
      name: 'Lucas Difference',
      navigation: 'right',
      component: LucasDifference,
      children: [
        {
          icon: 'nav-difference',
          name: 'Why Choose Us',
          path: '/lucas-difference#choose'
        }
        // {
        //   icon: 'nav-smile-gallery',
        //   name: 'Smile Gallery',
        //   path: '/lucas-difference#gallery'
        // }
      ]
    },
    {
      path: '/new-patients',
      name: 'New Patients',
      navigation: 'right',
      component: NewPatients,
      children: [
        {
          icon: 'nav-first-visit',
          name: 'Your First Visit',
          path: '/new-patients#first'
        },
        // {
        //   icon: 'nav-contact',
        //   name: 'Patient Forms',
        //   path: '/new-patients#forms'
        // },
        {
          icon: 'nav-finances',
          name: 'Financial & Insurance Help',
          path: '/new-patients#finance'
        }
        // {
        //   icon: 'nav-types-braces-invisalign',
        //   name: 'Lucas Kids Club',
        //   path: '/new-patients#kids'
        // }
      ]
    },
    {
      path: '/blog',
      name: 'Blog',
      navigation: 'right',
      component: Blog
    },
    {
      path: '/contact',
      name: 'Contact',
      navigation: 'right',
      component: Contact,
      children: [
        {
          icon: 'nav-contact',
          name: 'Contact Form',
          path: '/contact#form'
        }
      ]
    },
    {
      path: '/accessibility',
      name: 'Accessibility',
      navigation: false,
      component: Accessibility
    },
    {
      path: '/thank-you',
      name: 'Thank You',
      navigation: false,
      component: ThankYou
    },
    {
      path: '/blog/:blogID',
      component: BlogTemplate
    },
    {
      path: '/styleguide',
      name: 'Styleguide',
      navigation: false,
      component: Styleguide
    },
    {
      path: '/*',
      name: 'page-not-found',
      navigation: false,
      component: PageNotFound
    }
  ],
  scrollBehavior
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js